import store from '@/store';

export function getMunicipalityNameByCode({ code }) {
  const option = store.getters['tenant/getAllMunicipalityOptions'].find(o => o.value === code);
  return option?.text || null;
}
